import React from 'react';
import './IconButton.scss';

export type IconButtonProps = {
    icon: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const IconButton: React.FC<IconButtonProps> = ({ icon, className, ...props }) => {
    const cn = `icon-button ${className ?? ''}`;

    return (
        <button className={cn} {...props}>
            {icon}
        </button>
    );
};
